'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _htmlToReact = require('html-to-react');

var _htmlToReact2 = _interopRequireDefault(_htmlToReact);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _genericTabs = require('../../generic-tabs');

var _heading = require('../../../atoms/heading');

var _heading2 = _interopRequireDefault(_heading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var htmlToReactParser = new _htmlToReact2.default.Parser();

var ORGANISM_NAME = 'generic-tabs';

var GenericTabs = function (_React$Component) {
  _inherits(GenericTabs, _React$Component);

  function GenericTabs(props) {
    _classCallCheck(this, GenericTabs);

    var _this = _possibleConstructorReturn(this, (GenericTabs.__proto__ || Object.getPrototypeOf(GenericTabs)).call(this, props));

    _this.handleChange = function (value) {
      _this.setState({ value: value });
    };

    _this.renderHeadline = function (headline) {
      if (headline) {
        return _react2.default.createElement(
          _heading2.default,
          { level: '2', className: ORGANISM_NAME + '__headline col-xs-12 text-xs-center' },
          htmlToReactParser.parse(headline.text)
        );
      }
      return null;
    };

    _this.state = { value: 0 };
    _this.sectionElement = null;
    return _this;
  }

  _createClass(GenericTabs, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          content = _props.content,
          config = _props.config,
          children = _props.children,
          className = _props.className,
          fireTracking = _props.fireTracking;


      var classes = (0, _classnames2.default)(ORGANISM_NAME, className);
      var list = content.list,
          headline = content.headline;

      var childrenArr = _react2.default.Children.toArray(children);
      var currentState = this.state.value || 0;

      return _react2.default.createElement(
        'section',
        {
          id: config.id || null,
          className: classes,
          'data-building-block': 'organism',
          ref: function ref(el) {
            _this2.sectionElement = el;
          }
        },
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(
            'div',
            { className: 'row' },
            this.renderHeadline(headline),
            _react2.default.createElement(_genericTabs.Tabs, _extends({}, list, {
              fireTracking: fireTracking,
              handleChange: this.handleChange,
              value: this.state.value
            })),
            _react2.default.createElement(
              'div',
              { className: ORGANISM_NAME + '__content col-xs-12' },
              childrenArr[currentState]
            )
          )
        )
      );
    }
  }]);

  return GenericTabs;
}(_react2.default.Component);

exports.default = GenericTabs;


GenericTabs.propTypes = {
  config: _propTypes2.default.shape({
    id: _propTypes2.default.string
  }),
  content: _propTypes2.default.shape({
    headline: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }),
    list: _propTypes2.default.shape({
      content: _propTypes2.default.shape({
        items: _propTypes2.default.arrayOf(_propTypes2.default.shape({
          text: _propTypes2.default.string.isRequired
        }).isRequired).isRequired
      })
    })
  }),
  children: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.element]).isRequired,
  className: _propTypes2.default.string,
  fireTracking: _propTypes2.default.func
};

GenericTabs.defaultProps = {
  config: {
    id: ''
  },
  content: {
    headline: {
      text: 'text'
    },
    list: {
      content: {
        items: [{
          text: 'text1'
        }, {
          text: 'text2'
        }]
      }
    }
  },
  className: '',
  fireTracking: function fireTracking() {}
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/generic-tabs/jsx/GenericTabs.js
// module id = 681
// module chunks = 4